import { render } from "./FormComp.vue?vue&type=template&id=4e4fe12c&scoped=true&ts=true"
import script from "./FormComp.vue?vue&type=script&lang=ts"
export * from "./FormComp.vue?vue&type=script&lang=ts"

import "./FormComp.vue?vue&type=style&index=0&id=4e4fe12c&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4fe12c"]])

export default __exports__